$mol_hotkey2 $mol_plugin
	event *
		^
		keydown? <=> keydown? null
	action *
